import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';

export default function TextArea({
  className = '',
  helperText = '',
  hideLabel = false,
  input = {},
  inputProps = {},
  maxLength = null,
  meta = {},
  required = false,
}) {
  const { touched, error } = meta;
  const label = input.value && !hideLabel;
  const notEmpty = label ? styles['not-empty'] : '';
  const classes = [
    styles.root,
    className,
    notEmpty,
    touched && error ? styles.isError : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div>
      <label className={styles.label}>{inputProps.label}</label>
      {required && <span className={styles.withAsterisk}> *</span>}
      <textarea
        className={classes}
        {...input}
        {...inputProps}
        data-gramm_editor="false"
        maxLength={maxLength}
      />
      <div>
        <span className={styles.error}>{touched && error && error}</span>
      </div>
      <div className={styles.wrapper}>
        {helperText && <span className={styles.info}>{helperText}</span>}
        <span className={styles.info}>
          {maxLength && `${input?.value?.length}/${maxLength}`}
        </span>
      </div>
    </div>
  );
}

TextArea.propTypes = {
  className: PropTypes.string,
  helperText: PropTypes.string,
  hideLabel: PropTypes.bool,
  input: PropTypes.object,
  inputProps: PropTypes.object,
  maxLength: PropTypes.number,
  meta: PropTypes.object,
  required: PropTypes.bool,
};
